import { createReducer } from '@reduxjs/toolkit';

import postOrderedParts, { clearPostOrderedParts } from '../../../thunks/coilovers/orderedParts/postOrderedParts';

const initialState = {
  loading: false,
  error: null,
  data: undefined,
};

const postOrderedPartsReducer = createReducer(initialState, {
  [postOrderedParts.pending]: (state) => ({
    ...state,
    loading: true,
    error: null
  }),
  [postOrderedParts.fulfilled]: (state, { payload }) => ({
    ...state,
    loading: false,
    data: payload,
  }),
  [postOrderedParts.rejected]: (state, { payload }) => ({
    ...state,
    loading: false,
    error: payload,
  }),
  [clearPostOrderedParts]: () => initialState
});

export default postOrderedPartsReducer;
